export enum ChartType {
  Top5_CMC = 'Top5_CMC ',
  Total_Volume = 'Total_Volume',
  Stablecoins_vs_M2 = 'Stablecoins_vs_M2',
  Spot_ETF_ETH_Total_AUM_Native = 'Spot_ETF_ETH_Total_AUM_Native',
  Spot_ETF_BTC_Total_AUM_USD = 'Spot_ETF_BTC_Total_AUM_USD',
  TVL_per_Protocols = 'TVL_per_Protocols',
  Spot_ETF_ETH_Flows_USD = 'Spot_ETF_ETH_Flows_USD',
  BTC_Dominance = 'BTC_Dominance',
  Indices_and_Crypto_Returns = 'Indices_and_Crypto_Returns',
  BTC_ETH_Correlation = 'BTC_ETH_Correlation',
  RWA_Stablecoins_Holders_Networks = 'RWA_Stablecoins_Holders_Networks',
  Spot_ETF_BTC_Total_AUM_Native = 'Spot_ETF_BTC_Total_AUM_Native',
  RWA_Money_Market_Funds_TVL_Issuers = 'RWA_Money_Market_Funds_TVL_Issuers',
  ETH_NASDAQ_Correlation = 'ETH_NASDAQ_Correlation',
  RWA_Private_Credit_TVL_Protocols = 'RWA_Private_Credit_TVL_Protocols',
  ETF_ETH_AUM_Issuer_USD = 'ETF_ETH_AUM_Issuer_USD',
  RWA_Volume_Stablecoins_VS_Visa = 'RWA_Volume_Stablecoins_VS_Visa',
  Spot_ETF_ETH_AUM_Native = 'Spot_ETF_ETH_AUM_Native',
  Spot_ETF_BTC_Flows_USD = 'Spot_ETF_BTC_Flows_USD',
  RWA_Private_Credit_TVL_Network = 'RWA_Private_Credit_TVL_Network',
  Spot_ETF_ETH_Total_AUM_USD = 'Spot_ETF_ETH_Total_AUM_USD',
  Spot_ETF_ETH_MarketShare = 'Spot_ETF_ETH_MarketShare',
  Spot_ETF_ETH_AUM_USD = 'Spot_ETF_ETH_AUM_USD',
  Spot_ETF_BTC_AUM_USD = 'Spot_ETF_BTC_AUM_USD',
  ETH_Stacked_Market_Shares = 'ETH_Stacked_Market_Shares',
  RWA_Total_TVL = 'RWA_Total_TVL',
  Spot_ETF_BTC_AUM_Native = 'Spot_ETF_BTC_AUM_Native',
  RWA_Most_Popular_Networks = 'RWA_Most_Popular_Networks',
  ETH_Network_Fees_Paid_USD = 'ETH_Network_Fees_Paid_USD',
  ETH_Network_Transaction_Counts = 'ETH_Network_Transaction_Counts',
  Spot_ETF_BTC_MarketShare = 'Spot_ETF_BTC_MarketShare',
  ETH_Staked_By_Entity = 'ETH_Staked_By_Entity',
  RWA_Total_Stablecoins_Euro_TVL = 'RWA_Total_Stablecoins_Euro_TVL',
  Volumes_CEX_DEX_EURONEXT = 'Volumes_CEX_DEX_EURONEXT',
  RWA_Money_Market_Funds_TVL_Networks = 'RWA_Money_Market_Funds_TVL_Networks',
  RWA_Most_Popular_Networks_No_Stablecoins = 'RWA_Most_Popular_Networks_No_Stablecoins',
  Stablecoins_Artemis_SupplyUsageUSD = 'Stablecoins_Artemis_SupplyUsageUSD',
  ETH_Network_Rent_Paid_USD = 'ETH_Network_Rent_Paid_USD',
  RWA_Total_Stablecoins_TVL = 'RWA_Total_Stablecoins_TVL',
  RWA_Private_Credit_NonTokenized_TVL_IMF = 'RWA_Private_Credit_NonTokenized_TVL_IMF',
  RWA_Total_TVL_No_Stablecoins = 'RWA_Total_TVL_No_Stablecoins',
  ETH_Network_Rent_Paid = 'ETH_Network_Rent_Paid',
  USD_Stablecoin_Marketcap = 'USD_Stablecoin_Marketcap',
  ETH_Perpetual_Futures_OpenInterest = 'ETH_Perpetual_Futures_OpenInterest',
  RWA_Money_Market_Funds_TVL_Products = 'RWA_Money_Market_Funds_TVL_Products',
  ETH_Staked_By_Entity_Percent = 'ETH_Staked_By_Entity_Percent',
  RWA_Ethereum_Stablecoins_TVL = 'RWA_Ethereum_Stablecoins_TVL',
  Crypto_Prices = 'Crypto_Prices',
  TVL_per_Blockchain = 'TVL_per_Blockchain',
  Stablecoins_Artemis_SectorsVolume = 'Stablecoins_Artemis_SectorsVolume',
  RWA_Holders_Networks = 'RWA_Holders_Networks',
  Stablecoin_Artemis_Transactions_ByRegionAjusted = 'Stablecoin_Artemis_Transactions_ByRegionAjusted',
  RWA_Money_Market_Funds_NonTokenized_TVL_FitchRatings = 'RWA_Money_Market_Funds_NonTokenized_TVL_FitchRatings',
  Stablecoins_Yields = 'Stablecoins_Yields',
  Stablecoins_Per_Network_RWA = 'Stablecoins_Per_Network_RWA',
  Stablecoins_Artemis_VolumeVsOtherFinancialSystems = 'Stablecoins_Artemis_VolumeVsOtherFinancialSystems',
}
